<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-data-table :items="historial" :headers="headers">
                    <template v-slot:item.created_at="{ item }">
                        <span>{{ item.created_at | format_date_time }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <a @click.stop="openModal(item)">
                            <v-icon
                                style="pointer-events: none; font-size: 25px"
                                small
                                class="mr-2"
                                color="red"
                                title="BORRAR"
                                >mdi-trash-can</v-icon
                            >
                        </a>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    props: ["id"],
    data() {
        return {
            historial: [],
            dialog: false,
            headers: [
                { text: "Estado", value: "estado.nombre", sortable: false },
                { text: "Fecha", value: "created_at", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
        };
    },
    mounted() {
        if (this.id) this.getHistorial();
    },
    watch: {
        id(val) {
            if (val) this.getHistorial();
        },
    },
    methods: {
        getHistorial() {
            axios.get(`api/historial-cliente-estado/${this.id}`).then((res) => {
                this.historial = res.data;
            });
        },

        openModal(item) {
            this.selectedItem = item;
            this.dialog = true;
        },
        deleteUser() {
            axios
                .get(`api/delete-historial-cliente/${this.selectedItem.id}`)
                .then(
                    (res) => {
                        this.$toast.sucs("Historial eliminado con éxito");
                        this.dialog = false;
                        this.getHistorial();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el historial");
                    }
                );
        },
    },
};
</script>
